/**
 * Tab Interaction Handlers
 *
 * Pure event delegation — no Redux, no CSS, no business logic.
 * The plugin passes callbacks; this module only routes DOM events to them.
 *
 * Mirrors the pattern established by createLotPolygonInteractionHandlers.
 *
 * @param {Function} onTabSelected - Called with tabValue string when a tab is clicked
 * @returns {{ onTabClick: Function }}
 */
function createTabInteractionHandlers(onTabSelected) {
  return {
    onTabClick({ tabValue }) {
      onTabSelected(tabValue);
    },
  };
}

export default createTabInteractionHandlers;
